import {SearchParamsInterface} from "../interface/SearchParamsInterface";
import configAxios from "../configuration/configAxios";
import {interceptorResponse} from "../../utils/decode/decoding";
import {errorHandlerServices, getError} from "../configuration/errorHandle";
import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {CorporateInvestmentInterface} from "../interface/query/corporate-investment-interface";

export const findProperties = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/property_assets/realEstateProperties`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/property_assets/realEstateProperties', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /property_assets/realEstateProperties`);
    })
}

export const useFindProperties = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findProperties(data),
    });
}

export const findCorporateInvestments = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/property_assets/corporateInvestments`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const resp: CorporateInvestmentInterface[] = interceptorResponse(response.data.object)
            if (resp === null || (resp && resp.length === 0)) {
                // msjLine(data.msj)
            }
            return resp
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/property_assets/corporateInvestments', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /property_assets/corporateInvestments`);
    })
}

export const useFindCorporateInvestments = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findCorporateInvestments(data),
    });
}
